import { useCallback, useEffect, useRef } from "react";
function useDebouncedTreeRefresh(callback, delayMs = 200) {
    const timeoutRef = useRef();
    const callbackRef = useRef(callback);
    callbackRef.current = callback;
    const refresh = useCallback(()=>{
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>callbackRef.current(), delayMs);
    }, [
        delayMs
    ]);
    useEffect(()=>()=>{
            clearTimeout(timeoutRef.current);
        }, []);
    return refresh;
}
export { useDebouncedTreeRefresh };
